import React, { FC } from 'react'
import { Card, CardInner } from 'components/Card'
import { Checkbox, FrozenFeeBySizeForm } from 'components/Form'
import { Spacer } from 'components/Utility'
import { UseHandleFrozenFee } from 'hooks/storeDeliveryFee/useHandleFrozenFee'
import { PackageSize } from 'types/storeDeliveryFee'

type Props = { PACKAGE_SIZES: PackageSize[] } & UseHandleFrozenFee

const StoreDeliveryFrozenFeeCard: FC<Props> = (props) => {
  const { frozenFees, handleFrozenFeeAmount, handleHasFrozenFee, hasFrozenFee, PACKAGE_SIZES } = props

  return (
    <Card isOutlined={true}>
      <CardInner>
        <Checkbox
          id={'frozen'}
          isChecked={hasFrozenFee}
          label={'クール便の追加料金を設定する'}
          onChange={handleHasFrozenFee}
          size={'large'}
        />
        {hasFrozenFee && (
          <>
            <Spacer size={12} />
            <FrozenFeeBySizeForm
              frozenFees={frozenFees}
              PACKAGE_SIZES={PACKAGE_SIZES}
              handleFrozenFeeAmount={handleFrozenFeeAmount}
            />
          </>
        )}
      </CardInner>
    </Card>
  )
}
export default StoreDeliveryFrozenFeeCard
